import React from 'react';
import { PriceBlock } from '@hpstellar/core';

import { useGetProductPrice } from '../../../hooks/useProductPrice';

export default ({ product }) => {
    const price = useGetProductPrice(product, { transformPriceProps: true });

    return <div className="price-container">{price && <PriceBlock {...price} />}</div>;
};
